export class Value {
  eventKey: string
  eventValue: string
  version: string
  lastVersion: string | null | undefined = null
  id: string
  serverTimestamp: number
  eventId: string | null | undefined = null

  constructor(
    eventKey: string,
    eventValue: string,
    version: string,
    lastVersion: string | null = null,
    id: string,
    serverTimestamp: number,
    eventId: string | null | undefined = null
  ) {
    this.eventKey = eventKey
    this.eventValue = eventValue
    this.version = version
    this.lastVersion = lastVersion
    this.id = id
    this.serverTimestamp = serverTimestamp
    this.eventId = eventId
  }
}

export interface ResponseHandler<T> {
  onSuccess(topic: string, request: any, response: T): void
  onFailure(topic: string, request: any, response: any): void
  onError(topic: string, request: any, exception: any): void
}

export interface BasicResponse {
  code?: number
  msg: string
}

/* 发送数据返回数据结构 */
export interface SyncDataResponse extends BasicResponse {
  data: {
    globalMessageId: string
    id: string
    version: string
  }
}

/* 查询id返回的数据结构 */
export interface GetMessageDataResponse extends BasicResponse {
  data: {
    clientTimestamp: number
    data: string
    globalMessageId: string
    id: string
    notifyType: string
    serverTimestamp: number
    version: string
  }
}

/* 查询类型返回的数据结构 */
export interface GetMessageDataNotifyResponse extends BasicResponse {
  data: [
    {
      clientTimestamp: number
      data: string
      globalMessageId: string
      id: string
      notifyType: string
      serverTimestamp: number
      version: string
    }
  ]
}
